export default {
  chooseGame: "Výběr hry",
  chooseGym: "Výběr posilovny",
  chooseMicrolearning: "Výběr microlearningu",
  learningPaths: "Kurzy",
  logOut: "Odhlásit se",
  support: "Podpora",
  termsOfUse: "Podmínky použití",
  remainingCreditPercentage: "zbývajících kreditů",
  switchOrganization: "Změnit organizaci",
  selectGroup: "Vybrat skupinu",
  profile: "Profil",
  history: "Historie",
  adminDashboard: "Administrátorský panel",
  managerDashboard: "Manažerský panel",
  myPerformance: "Moje výkony",
  compactModePromptTitle: "Použít kompaktní režim?",
  compactModePromptDescription: "Vaše aktuální nastavení zoomu v prohlížeči způsobuje, že rozhraní může být stísněné. Zapnutím kompaktního režimu se stránka přizpůsobí menšímu prostoru. Tento režim můžete kdykoliv vypnout v levém menu.",
  compactModeAccept: "Zapnout kompaktní režim",
  compactModeDecline: "Ponechat standardní rozložení",
  enableCompactMode: "Zapnout kompaktní režim",
  disableCompactMode: "Vypnout kompaktní režim",
};
